const FiltersReducer = (state, action) => {
  switch (action.type) {
    case "setPriceRange":
      return { ...state, priceRange: action.payload };
    case "setCategoryFilter":
      const updateCatg = action.payload;
      const pCateogoryFilter = state.categoryFilter ?? [];
      const isInCart = pCateogoryFilter && pCateogoryFilter.some(item => item._id === updateCatg._id);

      return {
        ...state,
        categoryFilter: isInCart
          ? state.categoryFilter.map(item =>
            item._id === updateCatg._id ? updateCatg : item
          )
          : [...state.categoryFilter, updateCatg]
      };
    case "setRemoveCateogory":
      return {
        ...state,
        categoryFilter: state.categoryFilter.filter(item => item._id !== action.payload._id),
      };
    case "setBrandFilter":
      const updateBrand = action.payload;
      const isInBrand = state.brandFilter.some(item => item === updateBrand);

      return {
        ...state,
        brandFilter: isInBrand
          ? state.brandFilter.map(item =>
            item._id === updateBrand ? updateBrand : item
          )
          : [...state.brandFilter, updateBrand]
      };
    case "setRemoveBrandFilter":
      return {
        ...state,
        brandFilter: state.brandFilter.filter(item => item !== action.payload),
      };
    case "setSortByPriceFilter":
      return {
        ...state,
        sortByPriceFilter: action.payload,
      };
    case "setMovementTypeFilter":
      console.log("setMovementTypeFilter", action.payload);
      return { ...state, filterListMovementType: action.payload };
    case "setPersonTypeFilter":
      return { ...state, filterListPersons: action.payload };
    case "setFilterConditionFilter":
      return { ...state, filterConditions: action.payload };
    case "setClear":
      return {
        ...state,
        search: "",
        priceRange: [],
        brandFilter: "",
        sortByPriceFilter: "",
        filterListMovementType: "",
        filterListPersons: "",
        filterConditions: ""
      };
    case "clearAndSetCategory":
      const insertCatg = action.payload;
      return {
        ...state,
        search: "",
        priceRange: [],
        brandFilter: [],
        sortByPriceFilter: "",
        filterListMovementType: "",
        filterListPersons: "",
        filterConditions: "",
        categoryFilter: insertCatg ? [insertCatg] : [],
      };

    default:
      return state;
  }
};
export { FiltersReducer };
